import React from "react";
import { Info } from "lucide-react";
import Tooltip from "./Tooltip";
import { cn } from "../../lib/utils";

/**
 * Ícone de informação ao lado de um título, número ou gráfico.
 *
 * Existe como primitivo para o ícone ser o mesmo em toda tela: mesmo tamanho, mesma cor, mesma
 * distância do título. Quando cada página monta o seu, eles saem levemente diferentes e a
 * interface fica desalinhada sem ninguém saber por quê.
 *
 * O texto é para o usuário final, não para quem programou: diga o que o número significa e de
 * onde ele vem, em uma ou duas frases, sem nome de campo, de tabela nem de endpoint.
 *
 *   <InfoHint texto="Quantos parceiros entregaram menos do que costumam entregar." />
 *
 * Acessibilidade: é um <button>, então chega pelo teclado. `rotulo` vira o nome lido por leitor
 * de tela — sem ele, todos os ícones da página se anunciam igual ("mais informações").
 */
export default function InfoHint({ texto, rotulo, className = "", tamanho = "sm" }) {
  if (!texto) return null;

  const dimensao = tamanho === "md" ? "h-4 w-4" : "h-3.5 w-3.5";

  return (
    <Tooltip content={texto} className="align-middle">
      <button
        type="button"
        aria-label={rotulo ? `Sobre ${rotulo}` : "Mais informações"}
        className={cn(
          "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-border bg-background text-foreground shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          className
        )}
      >
        <Info className={dimensao} strokeWidth={2.5} aria-hidden="true" />
      </button>
    </Tooltip>
  );
}
